import { ResponseError } from './request'


export type Request<T> = Readonly<{
  method: string
  url: string
  error: (err: ResponseError) => string
  defaultState: T
}>

/**
 * REQUEST settings
 */

export type Settings = Readonly<{
  title: string
  lang: string
  template: string
  theme: string
}>

export const GET_SETTINGS: Request<Settings> = {
  method: 'GET',
  url: 'website/menu/settings',
  error: () => 'template_cafeteria_menu.api_errors.settings',
  defaultState: {
    lang: 'ru',
    template: 'general',
    theme: 'lime',
  } as Settings
}

/**
 * REQUEST supplier
 */

export type Supplier = Readonly<{
  title: string
  address: string
  inn: string
  kpp: string
  ogrn: string
  phone: string
  email: string
}>

export const GET_SUPPLIER: Request<Supplier> = {
  method: 'GET',
  url: 'website/menu/supplier',
  error: () => 'template_cafeteria_menu.api_errors.supplier',
  defaultState: {
    title: '',
    address: '',
    inn: '',
    kpp: '',
    ogrn: '',
    phone: '',
    email: '',
  } as Supplier
}

/**
 * REQUEST sell points
 */

export type SellPoints = ReadonlyArray<{
  id: number
  title: string
  building_id: number
  building_title: string
}>

export const GET_SELL_POINTS: Request<SellPoints> = {
  method: 'GET',
  url: 'website/menu/points',
  error: () => 'template_cafeteria_menu.api_errors.sellpoints',
  defaultState: [] as SellPoints
}

/**
 * REQUEST categories
 */

export type Categories = ReadonlyArray<{
  id: number
  title: string
}>

export const GET_CATEGORIES: Request<Categories> = {
  method: 'GET',
  url: 'website/menu/categories',
  error: () => 'template_cafeteria_menu.api_errors.categories',
  defaultState: [] as Categories
}

/**
 * REQUEST dishes
 */

export type Dishes = ReadonlyArray<{
  id: number
  title: string
  image: string
  category_id: number
  portion: string
  cost: number
  guid: string
  sale_point_id: number
}>

export const GET_DISHES: Request<Dishes> = {
  method: 'GET',
  url: 'website/menu/dishes',
  error: () => 'template_cafeteria_menu.api_errors.dishes',
  defaultState: [] as Dishes
}

/**
 * REQUEST dishes kits
 */

export type DishesKits = ReadonlyArray<{
  id: number
  title: string
  image: string
  guid: string
  cost: number
  items: ReadonlyArray<{
    title: string
    portion: string
    cost: number
  }>
}>

export const GET_DISHESKITS: Request<DishesKits> = {
  method: 'GET',
  url: 'website/menu/complexes',
  error: () => 'template_cafeteria_menu.api_errors.disheskits',
  defaultState: [] as DishesKits
}
